import React, { useEffect } from 'react';
const GIVEBUTTER_SRC = 'https://widgets.givebutter.com/latest.umd.cjs?acct=nOKVDCgTWSizVc5w&p=other';

/**
 * Loads the Givebutter widget script once for the whole app.
 * The script renders the account's donate button/modal.
 */
export function GivebutterDonate() {
  useEffect(() => {
    if (document.querySelector(`script[src="${GIVEBUTTER_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = GIVEBUTTER_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return null;
}